import { render } from "./ModalPaid.vue?vue&type=template&id=46b08210&scoped=true"
import script from "./ModalPaid.vue?vue&type=script&lang=js"
export * from "./ModalPaid.vue?vue&type=script&lang=js"

import "./ModalPaid.vue?vue&type=style&index=0&id=46b08210&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b08210"]])

export default __exports__